import { Injectable } from '@angular/core';
import { NudgeBase } from './nudge-base';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class NudgeService {
  nudgeMessages : NudgeBase[] = [];
  totalMessages : Subject<number> = new Subject<number>();
  currentNudge: number = 1;

  constructor( private _matSnackBar :MatSnackBar) { }


  // Adds the nudge to the nudgeMessages
  addNudge( nudge : NudgeBase){
    let id = this.nudgeMessages.length;
    nudge.id = id;
    this.nudgeMessages.push(nudge);
    this.totalMessages.next(this.nudgeMessages.length);
    if(this.nudgeMessages.length === 1){
      this.displayNudge();
    }
  }

  //Displays the next nudge if any
  onNudgeDismissed(){
    if(this.nudgeMessages.length === (this.currentNudge)){
      this.currentNudge = 1;
      this.nudgeMessages = [];
      return;
    }
    this.currentNudge++;
    if(this.nudgeMessages.length > 0){
      this.displayNudge();
    }
    this.totalMessages.next(this.nudgeMessages.length);
  }

  // calls the show nudge and 
  // waits for it to dismiss to open another nudge if any 
  displayNudge(){
    const snackBar = this.nudgeMessages[this.currentNudge - 1].showNudge(this._matSnackBar,this.currentNudge);
    snackBar.afterDismissed().subscribe(() => {
      this.onNudgeDismissed();
    });
  }
}
